import { render, staticRenderFns } from "./UpdateImport.vue?vue&type=template&id=dcf80bd6&"
import script from "./UpdateImport.vue?vue&type=script&lang=js&"
export * from "./UpdateImport.vue?vue&type=script&lang=js&"
import style0 from "./UpdateImport.vue?vue&type=style&index=0&id=dcf80bd6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports